import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface SucessDialogProps {
  message: string;
  open: boolean;
  onClose: () => void;
}

export const OperationSucessDialog = ({ open, onClose, message }: SucessDialogProps) => {
  const handleClickOpen = () => {
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Request processed successfully.</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus size="small">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
